<div
    #zoomContainer
    class="imageZoomContainer"
   
>
    <img
    onerror="this.src='assets/images/products/noImage/no-image.png';" 
        #imageThumbnail
        class="imageZoomThumbnail"
        [alt]="altText"
        [title]="titleText"
        [src]="thumbImage"
        (load)="onThumbImageLoaded()"
    />

    <div
        [ngClass]="{
            imageZoomFullContainer: true,
            imageZoomLensEnabled: this.enableLens}"
        [style.display]="this.display"
        [style.top.px]="this.lensTop"
        [style.left.px]="this.lensLeft"
        [style.width.px]="this.lensWidth"
        [style.height.px]="this.lensHeight"
        [style.border-radius.px]="this.lensBorderRadius"
    >
        <img
        onerror="this.src='assets/images/products/noImage/no-image.png';" 
            #fullSizeImage
            class="imageZoomFull"
            [alt]="altText"
            [title]="titleText"
            [src]="fullImage"
            (load)="onFullImageLoaded()"
            [style.display]="this.display"
            [style.top.px]="this.fullImageTop"
            [style.left.px]="this.fullImageLeft"
            [style.width.px]="this.magnifiedWidth"
            [style.height.px]="this.magnifiedHeight"
        />
    </div>
</div>